import React from 'react';
import { Box, Typography } from '@mui/material';

function Hero() {
    return (
        <Box
            id="mentorship"
            sx={{
                textAlign: 'center',
                py: 8,
                px: 4,
                backgroundImage: 'url(/img/csn-hero.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fff',
            }}
        >
            <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#fff' }}>
                Unite and Innovate
            </Typography>
            <Typography variant="h6" color="#e0e0e0">
                Connect, collaborate, and grow with cloud and security enthusiasts and professionals worldwide.
            </Typography>
        </Box>
    );
}

export default Hero;
